import axios from "axios";
import { API_BASE_URL, getRequest } from "../../api";

const token = () => sessionStorage.getItem("token") || "";
const headers = () => ({
  Authorization: `Bearer ${token()}`,
  uid: sessionStorage.getItem("uid"),
  "X-Tenant-Id": sessionStorage.getItem("selectedCompanyId"),
});

export const fetchLmsGlobalReport = (moduleId) =>
  getRequest({
    url: `${API_BASE_URL}/api/responsable/modules/${moduleId}/lms/reporting`,
    token: token(),
  }).then((response) => response.data);

export const fetchLmsLearnerReport = (moduleId, userId) =>
  getRequest({
    url: `${API_BASE_URL}/api/responsable/modules/${moduleId}/lms/reporting/users/${userId}`,
    token: token(),
  }).then((response) => response.data);

export const fetchLmsContentReport = (moduleId, contentId) =>
  getRequest({
    url: `${API_BASE_URL}/api/responsable/modules/${moduleId}/lms/reporting/contents/${contentId}`,
    token: token(),
  }).then((response) => response.data);

export const exportLmsGlobalReport = (moduleId) =>
  axios.get(`${API_BASE_URL}/api/responsable/modules/${moduleId}/lms/reporting/export`, {
    headers: headers(),
    responseType: "blob",
  });
